export * from './activity.module';

export { ActivityComponent } from './components/activity.component';
export { ActivityMainComponent } from './components/activity-main.component';




// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/activity/index.ts